import axios from 'axios';
import { endpoints } from 'utils/global-constants';

export const payForOrder = async (paymentFormData) => {
  const paymentPayload = {
    paymentData: {
      PaymentDetails: {
        CardName: paymentFormData.inputCardName || null,
        CardNumber: paymentFormData.inputCardNo || null,
        ExpiryDate: paymentFormData.inputCardDate || null,
        SecurityCode: paymentFormData.inputCardSecurity || null,
      },
      PersonalInformation: {
        PhoneNumber: paymentFormData.inputPhone,
        PostCode: paymentFormData.inputPostcode,
      },
      HearFromPresenter: paymentFormData.subscribeCheckboxSelected,
      HearFromAsiaTopaPresenter: paymentFormData.subscribeAsiaCheckboxSelected,
      GiftCertificateNumber: paymentFormData.giftCertificateNumber,
      AgreeToTCs: paymentFormData.checkboxTerms,
    },
  };

  try {
    const response = await axios.post(endpoints.payForOrder, paymentPayload);
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const addDonation = async (donationPayload) => {
  try {
    const response = await axios.post(endpoints.addDonation, donationPayload);
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/**
 * Apply Gift card to Order
 * @param {string} giftCardCode
 */
export const applyGiftCertificate = async (giftCertificateNumber) => {
  const payload = {
    giftCertificateNumber,
  };
  try {
    const response = await axios.post(endpoints.applyGiftCertificate, payload);
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/**
 * Apply Gift card to card payment
 * @param {string} giftCardCode
 */
export const unapplyGiftCertificate = async (giftCertificateNumber) => {
  const payload = {
    giftCertificateNumber,
  };
  try {
    const response = await axios.post(endpoints.unapplyCertificate, payload);
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};
